/* Landing de marca / fabricante — animaciones compartidas.
   Reveal al hacer scroll (.fbr-rv -> .is-in) + contador (data-count).
   Respeta prefers-reduced-motion. Idempotente (se puede cargar varias veces). */
(function () {
  if (window.__fbrInit) return;
  window.__fbrInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initReveal() {
    var items = document.querySelectorAll('.fbr-rv:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    if (reduce) { el.textContent = prefix + target.toLocaleString('es-ES') + suffix; return; }
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + Math.round(target * eased).toLocaleString('es-ES') + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounts() {
    var nums = document.querySelectorAll('[data-count]:not([data-done])');
    if (!('IntersectionObserver' in window)) { nums.forEach(function (el) { el.setAttribute('data-done', '1'); countUp(el); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.setAttribute('data-done', '1'); countUp(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { io.observe(el); });
  }

  ready(function () { initReveal(); initCounts(); });

  // Soporte editor de temas: re-inicializar al recargar secciones
  document.addEventListener('shopify:section:load', function () { initReveal(); initCounts(); });
})();
